import { render, staticRenderFns } from "./ShortlistSection.vue?vue&type=template&id=61e8a3e4&"
import script from "./ShortlistSection.vue?vue&type=script&lang=js&"
export * from "./ShortlistSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports